import { styled } from "styled-components";
import ProgressBar from "src/components/ProgressBar"
import NavigationController from "src/pages/Play/NavigationController";
import { theme } from "src/styles/theme";
import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTotalVideoDuration, shuffleArray } from "src/shared/utils/helper";
import { Tooltip as ReactTooltip } from "react-tooltip";
import MultipleVideoPlayer from "src/components/MultipleVideoPlayer";
import { Video } from "src/types/data";
import ReactPlayer from "react-player";
import { useMediaQuery } from "react-responsive";

const Container = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    // gap: 25px;
`;
const P = styled.p`
   color:#1C1C1C33;

`;
const VideoContainer = styled.div`
    width: 100%;
    height: 100%;
    gap: 20px;
    border-radius: 320px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;


`;

const DynamicBackground = styled.div<{bg?: string}>`
    width: 1258px;
    height: 717px;
    position: absolute;
    top: 20%;
    left: 30%;
    background-image: url(${props=>props.bg});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.15;
    filter: ${theme.blur.heavy};
    z-index: 0;
    pointer-events: none;
`;

const PlayerHost = styled.div<{size?: string}>`
   aspect-ratio: 1 / 1;
    flex:1;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 80vw;
`;
const HelpButton = styled.button`
  position: fixed;
  right: 20px;
  bottom: 50px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background-color: #000;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  z-index: 999;
`;

interface QCastProps{
    videoLists: any[];
    selectQcastIndex: number;
    onUpdateQcastIndex: (index: number) => void
    onResponse: () => void
}

interface VideProps{
    index: number;
    status: "PLAYED" | "PLAYING" | "TOPLAY";
    progress: number;
    duration: number;
}

const QCastContent: React.FC<QCastProps>=({videoLists, selectQcastIndex, onUpdateQcastIndex, onResponse})=>{
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [progress, setProgress] = useState<number>(0);
    const [seekVideo, setSeekVideo] = useState<{status:boolean;to?:number}>({status:false});
    const [totalPlayedDuration, setTotalPlayedDuration] = useState<number>(0);
    const [totalDuration, setTotalDuration] = useState<number>(0);
    const [playing, setPlaying] = useState(false);
    const [muteVideo, setMuteVideo] = useState(false);
    const [videos, setVideos] = useState<VideProps[]>([]);
    const [multiVideos, setMultiVideos] = useState<Video[]>([]);
    const [repeatPlayback, setRepeatPlayback] = useState<boolean>(false);
    const isNotPC = useMediaQuery({ maxWidth: theme.breakpoints.mobile });
    

    const [pause, setPause] = useState<"PLAYED" | "PLAYING" | "TOPLAY">("TOPLAY");
    const [seeking, setSeeking] = useState<boolean>(false);

    const navigate = useNavigate();
    
    const handleChangeQcast =(index: number)=>{
        
        if(index === -1 && currentIndex === 0) {
            setSeekVideo({status:true,to:0})
            return
        };
        if(index === 1 && currentIndex === videoLists.length - 1) return;
        const newIndex=currentIndex+index;
        onUpdateQcastIndex(currentIndex + index)
        setCurrentIndex(newIndex);
        setVideos(videoLists.map((video, index)=>{
            if(index==newIndex){
                return {...video,progress:0}
            }else{
                return {...video}
            }
        }));
        
    }
    const handleSelectVideo = (index: number) => {
        onUpdateQcastIndex(index);
        setCurrentIndex(index);
    };

    const handleResponse = ()=>{
        onResponse();
        // navigate("/respond", {state: {qcastVideo: videoLists[currentIndex]}})
    }

    const handleDuration = (durationVid: any) => {
      /*   let duration=0
        if (currentIndex<=0){
            duration=durationVid
        }else{
            duration=durationVid-(videos[currentIndex-1]?.duration||0)
        }
        setVideos(prev =>
            prev.map((video, i) => 
              i === currentIndex ? { ...video, duration, durationss:"not-sve2" } : { ...video, durationss:"not-sve" }
            )
        );
        setTotalDuration(prev => prev + duration); */
    };

    const handleVideoEnded = ()=>{
        if(currentIndex === videoLists.length - 1) {
            return;
        }
        setCurrentIndex((prev)=>prev+1);
    }

    const handlePlay=(status: boolean)=>{
        setPlaying(status);
    }

    const handleProgress=(prog: number)=>{
        
        setProgress(prog);
    }

    // const handleDuration=(dura: number)=>{
    //     setTotalDuration(dura);
    // }

    const handleNextVideo=(index: number)=>{
        setCurrentIndex(index);
    }
    const handleRepeatPlayback=(value: boolean)=>{
        setRepeatPlayback(value);
    }

    const handleMuteVideo = (status: boolean)=>{
        setMuteVideo(status);
    }

    const handleShuffle = () => {
        const shuffledVideo = shuffleArray(videoLists);
        setVideos(shuffledVideo);
     };

    // const calculateVideosDurations = async()=>{
    //     const totalDuration = await getTotalVideoDuration(videoLists);
    //     setTotalDuration(totalDuration);
    // }

    useEffect(()=>{
        if(selectQcastIndex !== currentIndex){
            setCurrentIndex(selectQcastIndex);
        }
    }, [selectQcastIndex])

    

    useEffect(()=>{
        let allVideos = videos;
        if(currentIndex > -1){
            const updatedVideos: any[] = videos.map((video, index)=>{
                if(index === currentIndex){
                    return{
                        ...video,
                        status: "PLAYING"
                    }
                }else if(index < currentIndex){
                    return{
                        ...video,
                        status: "PLAYED"
                    }
                }else{
                    return{
                        ...video,
                        status: "TOPLAY"
                    }
                }
            });
            allVideos = updatedVideos;
        }

        
        if(playing && progress > 0){
            const updatedVideos: any[] = videos.map((video, index)=>{
                if(index === currentIndex){
                    return{
                        ...video,
                        status: "PLAYING",
                        progress
                    }
                }
                return video;
            })
            allVideos = updatedVideos;
        }
        setVideos(allVideos);
    }, [playing, progress, currentIndex]);

    useEffect(()=>{
        if(videoLists.length > 0){
            setVideos(videoLists.map((video, index)=>({
                ...video,
                index: index + 1,
                status: "TOPLAY",
                progress: 0
            })));
            
            setMultiVideos(videoLists.map((video: any, index)=>({
                url: video.url,
                title: video.question
            })));

            // calculateVideosDurations();
        }
    }, [videoLists]);


    useEffect(()=>{
        if(videos.length === 0) return;
        
        const total = videos.reduce((sum, video) => sum + video?.duration, 0);
        setTotalDuration(total);
    }, [videos]);
    return(
        <Container>
            {/* <DynamicBackground  bg={"https://randomuser.me/api/portraits/women/44.jpg"} /> */}
            
            <VideoContainer>
            <P>Qcast Preview</P>
                <PlayerHost size={"320px"}>
                    
                    <MultipleVideoPlayer 
                        videos={multiVideos} 
                        currentIndex={currentIndex}
                        size={"320px"}
                        repeatVideoPlayback={repeatPlayback}
                        playing={playing}
                        muteVideo={muteVideo}
                        onVideoEnded={handleVideoEnded}
                        onProgress={handleProgress}
                        onDuration={()=>{}}
                        onPause={handlePlay}
                        onSeek={()=>{}}
                        seekVideo={seekVideo}
                        onNextVideo={handleNextVideo}
                    />
                </PlayerHost>
                
                <NavigationController hideResponse={true} onNavigate={handleChangeQcast} onResponse={handleResponse} />
            </VideoContainer>
            {/* {videos && videos.length>0 ? videos[currentIndex].duration : 0} */}
            <ProgressBar 
                currentIndex={currentIndex}
                videos={videos} 
                playing={playing}
                progress={progress} 
                onSelectVideo={handleSelectVideo}
                totalDuration={totalDuration} 
                onPlay={handlePlay} 
                onRepeat={handleRepeatPlayback}
                onMute={handleMuteVideo}
                onShuffle={handleShuffle}
                hideQueueBtn={true}
                hideRepeat={true}
                hideShuffle={true}
            />
            <HelpButton data-tooltip-id={`question-tooltip`}>?</HelpButton>
              <ReactTooltip
                    id={`question-tooltip`}
                    style={{width:"250px",zIndex:"999",backgroundColor: "rgba(255, 255, 255,1)", color: "#222",borderRadius:10 }}
                    place="top"
                    content={"Before recording your response to this Qcast, you can preview the questions by pressing the play button.Questions also play during your interview recording."}
                  />
                  
        </Container>
    )
}

export default QCastContent